import { OpenNewWindow } from '../../_common'

function BeforeAvailable() {
  return (
    <>
      <h1 className="cb-margin-bottom-16 cb-font-weight-regular">
        Prepare to Choose a Recipient for Your Free AP Score Report
      </h1>
      <p>
        Each year you take AP Exams, you can have your AP score report sent for free to one
        recipient (a college, university, or scholarship organization). Your official score report
        includes the scores from all AP Exams taken this year and any AP Exams you&#39;ve previously
        taken, along with certain demographic information about you and other information you
        provide during testing. Schools use your official score report to determine credit or
        placement, if applicable. Colleges, universities, and scholarship programs that you send
        your score to may also use your information and official score report to contact you with
        information about admissions, educational, financial aid, and scholarship opportunities.
      </p>
      <p>
        <OpenNewWindow url="https://apstudent.collegeboard.org/creditandplacement/search-credit-policies">
          Explore college AP credit policies{' '}
          <i className="cb-glyph cb-east" aria-hidden={true} style={{ fontSize: '.85em' }} />
          <span className="sr-only"> (Opens in a new window)</span>
        </OpenNewWindow>
      </p>
    </>
  )
}

export default BeforeAvailable
